<div class="flex flex-col">
  <kp-global-search-input
    class="h-16"
    [searchTerm]="searchTerm"
    (filterEvent)="filterEvent.emit($event)"
  ></kp-global-search-input>
  <mat-divider></mat-divider>

  <!-- TABLE -->
  <mat-table *ngIf="!loading" class="h-[calc(100vh-492px)] overflow-y-auto" [dataSource]="dataSource">
    <!-- CHECKBOX -->
    <ng-container matColumnDef="select">
      <mat-header-cell *matHeaderCellDef>
        <mat-checkbox
          id="selectAll"
          (change)="$event ? toggleAllRows() : null"
          [checked]="selection.hasValue() && isAllSelected()"
          [indeterminate]="selection.hasValue() && !isAllSelected()"
        >
        </mat-checkbox>
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <mat-checkbox
          (click)="$event.stopPropagation()"
          (change)="$event ? selection.toggle(row) : null"
          [checked]="selection.isSelected(row)"
        >
        </mat-checkbox>
      </mat-cell>
    </ng-container>
    <!-- / CHECKBOX -->

    <!-- NAME COLUMN -->
    <ng-container matColumnDef="name">
      <mat-header-cell *matHeaderCellDef>
        <ng-container *ngIf="selection.selected.length; else elseBlock">
          {{ 'JOB_MANAGEMENT.MESSAGE_ALL_SELECTED' | kpPluralizeTranslate : { value: selection.selected.length } }}
        </ng-container>
        <ng-template #elseBlock>{{ 'JOB_MANAGEMENT.NAME_TAB' | transloco }}</ng-template>
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span class="whitespace-nowrap text-ellipsis overflow-x-hidden">{{ row.name }}</span>
      </mat-cell>
    </ng-container>
    <!-- / NAME COLUMN -->

    <!-- MENU -->
    <ng-container matColumnDef="menu">
      <mat-header-cell *matHeaderCellDef>
        <ng-container *ngIf="selection.selected.length; else elseMenuBlock">
          <button id="multipleDelete" mat-icon-button class="scale-90" (click)="onDelete()">
            <mat-icon>delete</mat-icon>
          </button>
        </ng-container>
        <ng-template #elseMenuBlock>
          <button mat-button color="primary" class="h-10 w-40" (click)="onOpenDialog()">
            <mat-icon>add</mat-icon>
            <span class="text-primary ml-2">{{ selectAddJobButtonLabel | transloco }}</span>
          </button>
        </ng-template>
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <button id="edit" mat-icon-button class="scale-90" (click)="onOpenDialog(row)">
          <mat-icon>edit</mat-icon>
        </button>
        <button id="delete" mat-icon-button class="scale-90" (click)="onDelete(row.id)">
          <mat-icon>delete</mat-icon>
        </button>
      </mat-cell>
    </ng-container>
    <!-- / MENU -->

    <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns" (click)="$event.stopPropagation()"></mat-row>
    <div *matNoDataRow class="h-[calc(100%-56px)] flex justify-center items-center">
      <span>{{ selectEmptyListMessage | transloco }}</span>
    </div>
  </mat-table>
  <!-- / TABLE -->

  <div *ngIf="loading" class="h-[calc(100vh-492px)] flex justify-center items-center">
    <mat-spinner class="my-8" color="accent" strokeWidth="4" diameter="40"></mat-spinner>
  </div>
</div>
